module.exports = __webpack_public_path__ + "img/HZ-A1255.1bbb530f.jpg";